import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

// import Login from "./containers/Pages/Login/Login";
import Dashboard from "./containers/Dashboard";

const PublicRoutes = (props) => {
  const location = useLocation();

  const { idToken } = props.state.auth;
  return (
    <Routes>
      {/* <Route path="*" element={<Navigate to="/signin" replace />} /> */}
      {/* <Route path="/" element={<Login />} />
      <Route path="signin" element={<Login />} /> */}
      {/* {idToken && <Route path="dashboard" element={<Dashboard />} />} */}
    </Routes>
  );
};

const mapStateToProps = (state) => {
  return {
    state,
  };
};

export default connect(mapStateToProps)(PublicRoutes);
